import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";
import { hasPermission } from "../../../../utils/utils";
import Autocomplete from "../../../AutoComplete";

const dealPipeline = ["Sales Pipeline", "Account Management Pipeline", "Prepales Pipeline"].map((item) => ({ id: item, value: item }));
const dealStage = ["Discovery Call",
	"Evaluating Platform",
	"Proposal Submitted",
	"Negotiation / Discussion",
	"Contract Won / Signup Complete",
	"Closed lost",
	"Delayed",
	"RFP"].map((item) => ({ id: item, value: item }));

const DealDetailsForm = ({
  productsList,
  dealDetails,
  editPermissions = true,
  dealStates,
  customerSearchValue,
  customerData,
  setCustomerSearchValue,
  customerLoading,
  handleCutomerChange,
  handleSubmit,
  formData,
  setFormData,
  errors,
  isEditing,
  setIsEditing,
  usersList,
}) => {

  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (dealDetails) {
      fetchFromData();
    }
  }, [dealDetails]);

  const fetchFromData = () => {
    setFormData({
      deal_name: dealDetails.deal_name || "",
      deal_description: dealDetails.deal_description || "",
      deal_value: dealDetails.deal_value || "",
      deal_state: dealDetails.deal_state || "",
      product: dealDetails.product || [],
      deal_status: dealDetails.deal_status,
      mautic_id: dealDetails.mautic_id,
      deal_owner: dealDetails.deal_owner || "",
      deal_pipeline: dealDetails.deal_pipeline || "",
      deal_stage: dealDetails.deal_stage || "",
		  reason: dealDetails.reason || "",
    });
  };

  const handleInputChange = (valueFor, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };


  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };



  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              // onSaveClick();
              handleSubmit();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="About this Deal"
      targetID="dealDetailsForm"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div className="form-customer-details">
        <div className="customer-info">
          <div className="row d-flex form-customer-activity align-items-center mb16">
            <div className="col-md-4">
              <label for="customer">Contact Name<span class="text-danger">*</span></label>
            </div>
            <div className="col-md-8">
              <Autocomplete
                name="mautic_id"
                isEditing={isEditing}
                value={customerSearchValue}
                items={customerData}
                valueProperty="value"
                labelProperty="label"
                isLoading={customerLoading}
                placeholder={"Select Contact Name"}
                onSelect={(value, item) => {
                  handleCutomerChange(item);
                }}
                onChange={(event, value) => {
                  setCustomerSearchValue(value);
                }}
              />
            </div>
          </div>
          <InputFieldControl
            fieldName="deal_owner"
            label="Deal Owner"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={usersList}
            multiSelect={false}
            isLoading={isLoading}
            error={errors.deal_owner}
            required={true}
          />
          <InputFieldControl
            fieldName="product"
            label="Products"
            type={"select"}
            isEditing={false}
            formData={formData}
            handleInputChange={handleInputChange}
            data={productsList}
            multiSelect={true}
            isLoading={isLoading}
            error={errors.product}
            required={true}
          />
          <InputFieldControl
            fieldName="deal_name"
            label="Deal Name"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.deal_name}
          />
          <InputFieldControl
            fieldName="deal_description"
            label="Deal Description"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.deal_description}
          />

          <InputFieldControl
            fieldName="deal_value"
            label="Deal Value ($)"
            type={"text"}
            isEditing={false}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.deal_value}
          />
          <InputFieldControl
            fieldName="deal_state"
            label="Deal State"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={dealStates}
            multiSelect={false}
            // isLoading={isLoading}
            error={errors.deal_state}
              required={true}
          />
           
          <InputFieldControl
            fieldName="deal_pipeline"
            label="Deal Pipeline"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={dealPipeline}
            multiSelect={false}
            // isLoading={isLoading}
            error={errors.deal_pipeline}
              required={true}
          />
          <InputFieldControl
            fieldName="deal_stage"
            label="Deal Stage"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={dealStage}
            multiSelect={false}
            // isLoading={isLoading}
            error={errors.deal_stage}
              required={true}
          />
          <InputFieldControl
            fieldName="deal_status"
            label="Deal Status"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            data={[{
              id: true,
              value: "Open",
            }, {
              id: false,
              value: "Closed",
            }]}
            multiSelect={false}
            // isLoading={isLoading}
            error={errors.deal_status}
              required={true}
          />
          <InputFieldControl
            fieldName="reason"
            label="Closed Reason"
            type={"text"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={false}
            error={errors.reason}
          />
        </div>
      </div>

    </Accordion>
  );
};

export default DealDetailsForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/DealDetailsForm.js